import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { ReporteData } from 'src/app/models';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { TipoVehiculoService } from 'src/app/services/tipo-vehiculo.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-reporte-dia',
  templateUrl: './reporte-dia.component.html',
  styleUrls: ['./reporte-dia.component.scss']
})
export class ReporteDiaComponent implements OnInit {
  formBusqueda:FormGroup;
  rows: ReporteData = null;
  colums = [{ name: 'FECHA CRUCE' }, { name: 'CARRIL' }, { name: 'TIPO VEHICULO' }, 
            { name: 'TARIFA' }, { name: 'CANTIDAD'}, { name: 'SUBTOTAL' }];
  ColumnMode = ColumnMode;
  loadingIndicator : boolean = false;
  carriles:any[] = [];
  tiposVehiculo:any[] = [];
  totalDineroCobrado:number = 0;
  constructor(private formBuilder: FormBuilder,
              private reporteService:ReporteriaService,
              private ngxUiLoaderService:NgxUiLoaderService,
              private toastr:ToastrService,
              private vehiculoService:TipoVehiculoService,
              private store: Store<AppState>) { }

  ngOnInit(): void {
    this.createForm();
    this.getData();
  }

  createForm(){
    this.formBusqueda = this.formBuilder.group({
      fecha: ['', Validators.required], //fecha obligatoria
      carriles : [''],
      vehiculos : ['']
    });

    this.formBusqueda.get('fecha').setValue(moment().format('YYYY-MM-DD'));//fecha actual
  }

   getData(){
    let caseta = this.getCasetaUser();
    this.reporteService.getCarriles(caseta.id)
    .then(carriles => {
      this.carriles = carriles;
      this.getTipoVehiculo();
    })
    .catch(error => {
      console.log(error);
    });
  }

   getCasetaUser(){
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });
    return casetaTroncal;
   }

   getTipoVehiculo(){
    this.vehiculoService.getClasificacionVehiculo()
    .subscribe(resultado => {
      this.tiposVehiculo = resultado;
    });
   }

   searchData(){
    this.loadingIndicator = true;
    let form = { ...this.formBusqueda.value, 'tipoReporte': 2 };
    this.reporteService.getDataReporte(1, form)//numero pagina , formData
    .subscribe(boletos => {
         this.loadingIndicator = false;
         console.log(boletos.data);
         this.rows = boletos;
         this.calcularTotal();
    });
   }

   setPage(event){
    console.log(event);
    this.loadingIndicator = true;
    let page = event.offset + 1;
    this.reporteService.getDataReporte(page, { ...this.formBusqueda.value, 'tipoReporte': 2})
    .subscribe(boletos => {
       console.log(boletos.data);
       this.rows = boletos;
       this.loadingIndicator = false;
       this.calcularTotal();
     });
   }
 
   calcularTotal(){
     this.totalDineroCobrado = 0;
     this.rows.data.forEach(boleto => {
        this.totalDineroCobrado += parseFloat(boleto.subtotal); 
     });
   }

   //Exportar excel
   exportFileExcel(){
      this.ngxUiLoaderService.start('2');
      let urlExcel:string;
      this.reporteService.descargarArchivo( {...this.formBusqueda.value, 'tipoReporte': 2})
      .then((file:Blob) => {
          let urlDownload = this.reporteService.downloadExcel(file,`reporte_dia_${moment().format('YYYY-MM-DD')}.xlsx`);
          if(urlDownload != ''){
            urlExcel = urlDownload;
            this.ngxUiLoaderService.stop('2');
            return this.toastr.success('Se ha descargado con éxito el archivo Excel', '', { positionClass: 'toast-bottom-right' })  
          }
      })
      .catch(error => {
        console.log(error);
        this.ngxUiLoaderService.stop('2');
        return this.toastr.error(`Por favor intenta de nuevo, ${error}`, 'Error al descargar', { positionClass: 'toast-bottom-right' })
      })
      .finally(() => {
        URL.revokeObjectURL(urlExcel);
      });
   }

}
